import InfluencerCard from "src/component/InfluencerCard";
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Typography,
  Button,
  Hidden,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { Pagination } from "@material-ui/lab";
import Apiconfigs from "src/ApiConfig/ApiConfig";
import axios from "axios";
import FilterBox from "../Socialaccount/FilterBox";
import NodatafoundImage from "src/component/DataDataNo";
import ButtonCircularProgress from "src/component/ButtonCircularProgress";
import useDebounce from "src/CutomHooks/Debounce";
import DataNotFound2 from "src/component/DatanotFound2";

const useStyles = makeStyles((theme) => ({
  influencerBox: {
    position: "relative",
    padding: "75px 0 0px",
    zIndex: "9",
    "& .leftcontent": {
      marginBottom: "32px",
      [theme.breakpoints.down("xs")]: {
        marginBottom: "100px",
      },
      "& .filterBoxNft": {
        display: "flex",
        alignItems: "center",
        border: "1px solid #717272",
        padding: "5px 15px",
        borderRadius: "12px",
        cursor: "pointer",
        "& h6": {
          marginLeft: "5px",
        },
      },
      "& h1": {
        fontFamily: "'ClashDisplay-Extralight'",
        "& span": { fontFamily: "'ClashDisplay-Medium'" },
      },
    },
  },
  searcBox: {
    "& .MuiOutlinedInput-root": {
      borderRadius: " 50px",
      height: "50px",
    },
    "& .MuiIconButton-root": {
      background: theme.palette.background.blur,
      marginLeft: "-20px",
      padding: "8px",
      "& svg": {
        marginLeft: "-3px",
      },
    },
  },
  displayNone: {
    display: "block",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
}));

const settings = {
  dots: false,
  slidesToShow: 4,
  // slidesToScroll: 1,
  arrows: true,
  centerMode: false,
  centerPadding: "0px",
  className: "recomended",
  autoplay: true,
  autoplaySpeed: 5000,
  // prevArrow: <CustomPrevArrow
  //   className={
  //     themeSeeting.settings.theme === "DARK"
  //       ? "sellerPaginationButton"
  //       : "sellerPaginationButtonLight"}
  // />,
  // nextArrow: <CustomNextArrow
  //   className={
  //     themeSeeting.settings.theme === "DARK"
  //       ? "sellerPaginationButton"
  //       : "sellerPaginationButtonLight"} />,
  infinite: true,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 4,
        arrows: true,
        centerMode: false,
        centerPadding: "50px",
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        arrows: true,
        centerMode: false,
        centerPadding: "50px",
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        arrows: true,
        centerMode: false,
        centerPadding: "50px",
      },
    },

    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        arrows: true,
        centerMode: false,
        centerPadding: "10px",
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        arrows: true,
        centerMode: false,
        centerPadding: "10px",
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        centerMode: false,
        arrows: true,
        centerPadding: "10px",
      },
    },
  ],
};
export default function Influencer() {
  const classes = useStyles();
  const [allListData, setAllListData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search1, setSearch] = useState("");
  const deb = useDebounce(search1, 1000);
  const [noOfTotalPages, setNoOfTotalPages] = useState(1);
  let limitD = window.location.pathname === "/Influencer-View" ? 8 : 8;

  const getTopInfluencerList = async () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: Adds smooth scrolling effect
    });
    try {
      let search;
      if (search1) {
        search = search1;
      }
      const res = await axios({
        method: "GET",
        url: Apiconfigs.getTopInfluencerList,
        params: {
          search,
          page: page,
          limit: limitD,
        },
      });
      if (res.data.statusCode === 200) {
        if (res.data.result.data) {
          setAllListData(res.data.result.data);
        } else {
          setAllListData([]);
        }
        setNoOfTotalPages(res.data.result.totalPages);
        setIsLoading(false);
      } else {
        setAllListData([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setAllListData([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTopInfluencerList();
  }, [page, deb]);
  return (
    <Box className={classes.influencerBox}>
      <Container>
        <Box className="leftcontent displaySpacebetween">
          <Typography variant="h1" color="primary">
            Top <span>Influencers</span>{" "}
          </Typography>
          {window.location.pathname === "/Influencer-View" ? (
            <FilterBox
              setSearch={setSearch}
              search={search1}
              newClasses={classes}
              searchName={"Influencer name..."}
            />
          ) : (
            <>
            {allListData .length > 8&&(<Button
              variant="outlined"
              color="primary"
              component={Link}
              to="/Influencer-View"
              style={{
                borderRadius: "10px",
                border: "2px solid rgba(255, 255, 255, 0.1) !important",
              }}
              className={classes.buttonright}
            >
              View All
            </Button>)}
          </>)}
        </Box>
        {isLoading && (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <ButtonCircularProgress />
          </Box>
        )}
        <Box
          className={
            window.location.pathname !== "/Influencer-View" &&
            classes.displayNone
          }
        >
          <Grid container spacing={3}>
            {allListData &&
              allListData.map((data) => {
                return (
                  <Grid item lg={3} md={3} sm={6} xs={12} align="center">
                    <InfluencerCard value={data} />
                  </Grid>
                );
              })}
          </Grid>
          {window.location.pathname === "/Influencer-View" &&
            !isLoading &&
            noOfTotalPages > 1 && (
              <Box align="center" mt={4} mb={2} className="displayCenter">
                <Pagination
                  count={noOfTotalPages}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                />
              </Box>
            )}
        </Box>

        {window.location.pathname !== "/Influencer-View" && (
          <Hidden smUp>
              <Slider
                {...settings}
                style={{ width: "100%" }}
                className="topslickslider"
              >
            <Grid container spacing={3}>
                {allListData.map((data) => {
                  return (
                    <Grid item md={12}  >
                      <InfluencerCard value={data} />
                    </Grid>
                  );
                })}
            </Grid>
              </Slider>
          </Hidden>
        )}
        {!isLoading && allListData?.length === 0 && (
          <DataNotFound2
            data={
              search1 == ""
                ? "Influencer list not found."
                : `Influencer with name '${search1}' not found.`
            }
          />
        )}
      </Container>
    </Box>
  );
}
